












































import { Result } from '@empathybroker/tsclient-search';

import EpbAside from '../aside.component.vue';
import { UiButton } from '../keen-ui';
import TransitionHeight from '../transition-height.component.vue';
import ExplainResultCard from './explain-result-card.component.vue';
import ExplainResultScoreRadarChart from './explain-result-score-radar-chart.component.vue';
import ExplainResultsTable from './explain-results-table.component.vue';

export default {
  name: 'epb-explain-results-aside',
  props: {
    results: {
      type: Array,
      required: true
    },
    collapsed: Boolean
  },
  components: {
    EpbAside,
    UiButton,
    TransitionHeight,
    ExplainResultCard,
    ExplainResultScoreRadarChart,
    ExplainResultsTable
  },
  data: function () {
    return {
      initialAnimationDurationInMillis: 2000,
      messages: this.$epb.messages.explain
    };
  },
  methods: {
    onClearSelectionClick: function (): void {
      this.$emit('removeResults', this.results.map((result: Result) => result.id));
    }
  }
};
